import { Controller } from "@hotwired/stimulus"
import { ModalLoaders } from "../utils/modal_loader"
import { confirmBeforeSubmit } from "../utils/form_confirmation"

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};

export default class extends Controller {
  static targets = []

  /**
   * フォーム送信前に確認ダイアログを表示します。
   * @param {Event} event - フォーム送信イベント
   * @returns {boolean} 確認でキャンセルされた場合はfalseを返します。
   */
  confirmBeforeSubmit(event) {
    return confirmBeforeSubmit(event, {
      submitButtonTarget: 'branches-target="submitButton"'
    })
  }

  /**
   * StimulusコントローラーがDOMに接続されたときに呼び出されます。
   * 編集モーダルのローダーを初期化します。
   */
  connect() {
    // センター編集モーダルのローダーを初期化
    this.modalLoader = ModalLoaders.createEditModal('branch')

    // 新規モーダルの初期HTMLを保存
    this.saveNewModalInitialHtml()
  }

  /**
   * 新規モーダルの初期HTMLを保存します。
   */
  saveNewModalInitialHtml() {
    const frame = document.getElementById('new_branch_modal_frame')
    if (frame && !this._newModalInitialHtml) {
      this._newModalInitialHtml = frame.innerHTML
    }
  }

  /**
   * 新規登録モーダルを閉じてフォームをリセットします。
   * バリデーションエラー後も初期状態に戻します。
   */
  closeNewModal() {
    const modal = document.getElementById('new_branch_modal')
    if (!modal) return

    // モーダルを閉じる
    modal.close?.() || modal.removeAttribute('open')

    // アニメーション完了後にHTMLを復元
    const resetModal = () => {
      const frame = document.getElementById('new_branch_modal_frame')
      if (frame && this._newModalInitialHtml) {
        frame.innerHTML = this._newModalInitialHtml
      } else if (modal) {
        // フォールバック: 単純なリセット
        const form = modal.querySelector('form')
        if (form) {
          form.reset()
          // エラーメッセージを削除
          form.querySelectorAll('.field_with_errors, .text-error, .alert-error').forEach(el => el.remove())
        }
      }
    }

    // アニメーション完了を待ってからリセット（DaisyUIのモーダルアニメーションは約200ms）
    setTimeout(resetModal, 300)
  }

  /**
   * 編集モーダルを開き、指定された営業所の編集フォームを読み込みます。
   * @param {Event} event - クリックイベント
   */
  openEditModal(event) {
    // データ属性からbranchIdを取得
    const branchId = event.currentTarget.dataset.branchId
    const queryString = window.location.search

    if (!branchId) {
      return
    }

    // モーダルローダーを使用してデータを読み込む
    this.modalLoader.loadWithTurboStream(`/branches/${branchId}/edit${queryString}`)
      .catch(error => {
        console.error('Branch edit modal error:', error)
      })
  }
}
